'use-strict';

import angular from 'angular';

import { DatasheetRequest, ExpiringPricingSticker, PricingStickerRequest } from 'src/app/@shared-types/print';
import { ApiService } from 'src/app/shared/services/api';
import { CustomTemplate } from '../../src/app/@shared-types/print/custom';

export class PrintAPIService {
  private apiService: ApiService;

  constructor(apiService: ApiService) {
    'ngInject';

    this.apiService = apiService;
  }

  public getPricingSticker = (
    stickerMeta: PricingStickerRequest,
  ): Promise<{ data: string }> => this.apiService.post<{ data: string }>('/api/print/pricing-sticker', stickerMeta);

  public getExpiringPricingStickers = (): Promise<ExpiringPricingSticker[]> => this.apiService
    .get<ExpiringPricingSticker[]>('/api/print/expiring-pricing-stickers');

  public getDatasheet = (
    datasheetMeta: DatasheetRequest,
  ): Promise<{ data: string }> => this.apiService.post<{ data: string }>('/api/print/datasheet', datasheetMeta);

  public getAllCustomTemplates = (): Promise<CustomTemplate[]> => this.apiService.get<CustomTemplate[]>('/api/print/custom-template');
}

export default angular.module('services.printApiService', [])
  .service('printApiService', PrintAPIService)
  .name;
